import { render, staticRenderFns } from "./MotionDuration.vue?vue&type=template&id=73e9c99a"
import script from "./MotionDuration.vue?vue&type=script&lang=js"
export * from "./MotionDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports